import React from 'react';
import { Download } from 'lucide-react';
import { Button } from '../components/ui/button';

const logos = [
  { name: 'Icon - Green (Primary)', file: 'logo-icon-green.svg', bg: 'bg-[#F5F2E8]' },
  { name: 'Icon - Dark', file: 'logo-icon-dark.svg', bg: 'bg-[#F5F2E8]' },
  { name: 'Icon - Light', file: 'logo-icon-light.svg', bg: 'bg-[#1A1A1A]' },
  { name: 'Icon Only (Transparent)', file: 'logo-icon-only.svg', bg: 'bg-[#F5F2E8]' },
  { name: 'Horizontal - Green Icon', file: 'logo-horizontal-green.svg', bg: 'bg-[#F5F2E8]' },
  { name: 'Horizontal - Dark', file: 'logo-horizontal-dark.svg', bg: 'bg-[#F5F2E8]' },
  { name: 'Horizontal - Light', file: 'logo-horizontal-light.svg', bg: 'bg-[#1A1A1A]' },
  { name: 'Stacked - Green Icon', file: 'logo-stacked-green.svg', bg: 'bg-[#F5F2E8]' },
  { name: 'Stacked - Dark', file: 'logo-stacked-dark.svg', bg: 'bg-[#F5F2E8]' },
  { name: 'Stacked - Light', file: 'logo-stacked-light.svg', bg: 'bg-[#1A1A1A]' },
  { name: 'Text Only - Dark', file: 'logo-text-only-dark.svg', bg: 'bg-[#F5F2E8]' },
  { name: 'Text Only - Light', file: 'logo-text-only-light.svg', bg: 'bg-[#1A1A1A]' },
];

const BrandAssets = () => {
  const handleDownload = async (filename) => {
    try {
      const response = await fetch(`/brand/${filename}`);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Download failed:', error);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F2E8] pt-24 pb-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8">
        {/* Header */}
        <div className="mb-12">
          <p className="text-[#4A7C29] text-[10px] font-semibold tracking-[0.2em] mb-2 font-['IBM_Plex_Sans_Condensed'] uppercase">TJGI — CORPORATE IDENTITY</p>
          <h1 className="text-3xl md:text-4xl font-semibold tracking-[0.05em] text-[#1A1A1A] font-['IBM_Plex_Sans_Condensed'] uppercase">
            BRAND ASSET REPOSITORY
          </h1>
          <p className="text-[#5A5A5A] mt-3 max-w-2xl font-['IBM_Plex_Sans']">
            SVG vector files for all approved logo variations. Select to initiate download.
          </p>
        </div>

        {/* Usage Guidelines */}
        <div className="bg-white border-2 border-[#E0DDD4] border-l-4 border-l-[#4A7C29] p-6 mb-8">
          <h2 className="text-sm font-semibold text-[#1A1A1A] mb-2 font-['IBM_Plex_Sans_Condensed'] uppercase tracking-wide">USAGE GUIDELINES</h2>
          <p className="text-[#5A5A5A] text-sm font-['IBM_Plex_Sans']">
            All brand elements must function in 100% black or 100% white. No gradients, shadows, or color dependencies. 
            The beaker must always be recognizable and functional as a single-color stencil.
          </p>
        </div>

        {/* Logo Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {logos.map((logo) => (
            <div 
              key={logo.file}
              className="bg-white border-2 border-[#E0DDD4] overflow-hidden hover:border-[#4A7C29] transition-colors"
            >
              <div className={`${logo.bg} p-8 flex items-center justify-center min-h-[200px]`}>
                <img 
                  src={`/brand/${logo.file}`} 
                  alt={logo.name}
                  className="max-w-full max-h-[150px] object-contain"
                />
              </div>
              <div className="p-4 flex items-center justify-between border-t border-[#E0DDD4]">
                <div>
                  <p className="font-semibold text-[#1A1A1A] text-sm font-['IBM_Plex_Sans_Condensed'] uppercase tracking-wide">{logo.name}</p>
                  <p className="text-xs text-[#5A5A5A] font-['IBM_Plex_Mono']">{logo.file}</p>
                </div>
                <Button
                  onClick={() => handleDownload(logo.file)}
                  variant="outline"
                  size="sm"
                  className="rounded-none border-2 border-[#E0DDD4] hover:border-[#4A7C29] hover:bg-[#F5F2E8]"
                >
                  <Download className="w-4 h-4" />
                </Button>
              </div>
            </div>
          ))}
        </div>

        {/* Raw SVG Section */}
        <div className="mt-16 bg-white border-2 border-[#E0DDD4] p-6">
          <h2 className="text-base font-semibold text-[#1A1A1A] mb-3 font-['IBM_Plex_Sans_Condensed'] uppercase tracking-wide">ACCESSING RAW SVG CODE</h2>
          <p className="text-[#5A5A5A] font-['IBM_Plex_Sans']">
            Right-click on any logo above and select "Open image in new tab", then view page source to copy the SVG code directly.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BrandAssets;
